export interface TimingInfo {
  responseHeaders: { [key: string]: string[] }
}
